import { useState } from 'react'
import { Grid2, Typography } from '@mui/material'
import { Field } from 'formik'
import { useAdminCity, useAdminSalesReport,  useClusterByZone } from '../../../assets/api/useAdminApi'
import TableFilterTemplate from '../../../shared/utils/TableFilterTemplate'
import { DateFormField } from '../../../shared/components/formfields/DataFormField'
import { useAllZoneList } from '../../../assets/api/useMarketingExecutive'
import { IdAutoCompleteField } from '../../../shared/components/formfields/IdAutoCompleteField'

const SalesReports = () => {
    const [filters, setFilters] = useState({});
    const [selectedZone, setSelectedZone] = useState(null);
    const [cityId, setCityId] = useState("")
    const [searchCity,setSearchCity]=useState("")
    const { data: salesReports, isLoading: isSalesReportLoading } = useAdminSalesReport(filters)
    const { data: ClusterList, isLoading: isClusterLoading } = useClusterByZone({ zone_id: selectedZone?.id })
const { data: cityList, isLoading: isCityLoading } = useAdminCity({search:searchCity},{ enabled: true })
    const ClusterOption = ClusterList?.map((item, index) => ({
        id: item?.id,
        value: item?.cluster_name,
        label: item?.cluster_name
    }))
    const { data: zoneList, isLoading: isLoadingZone } = useAllZoneList({ city_id: cityId })
    const ZoneOption = zoneList?.data?.map((item, index) => ({
        id: item?.id || index + 1,
        label: item?.zone_name,
        value: item?.zone_name
    })) || [];

    const CityOptions = cityList?.data?.map((city) => ({
        id: city?.id,
        label: city?.city_name,
        value: city?.city_name,
    })) || []
    const salesReportColumn = [
        {
            field: "sr_no",
            headerName: "Sr No",
            flex: 1,
            renderCell: (params) => <Typography variant="body2">{params.value}</Typography>

        },
        {
            field: "apartment_name",
            headerName: "Apartment Name",
            flex: 1,
            renderCell: (params) => <Typography variant="body2">{params.value}</Typography>,
        },
        {
            field: "added_count",
            headerName: "Added Count",
            flex: 1,
            renderCell: (params) => <Typography variant="body2">{params.value}</Typography>,
        },
        {
            field: "enquiry_date",
            headerName: "Enquiry Date",
            flex: 1,
            renderCell: (params) => <Typography variant="body2">{params.value}</Typography>,
        },
        {
            field: "notinterested_count",
            headerName: "Not Interested Count",
            flex: 1,
            renderCell: (params) => <Typography variant="body2">{params.value}</Typography>,
        },
        {
            field: "sales_count",
            headerName: "Sales Count",
            flex: 1,
            renderCell: (params) => <Typography variant="body2">{params.value}</Typography>,
        },
        {
            field: "total_enquiries",
            headerName: "Total Enquiries",
            flex: 1,
            renderCell: (params) => <Typography variant="body2">{params.value}</Typography>,
        }
    ];

    return (
        <>
            <TableFilterTemplate
                title="Sales Report"
                columns={salesReportColumn}
                rowsData={salesReports?.data || []}
                isLoading={isSalesReportLoading}
                filterInitialValues={filters}
                filterReset={() => setFilters({})}
                onApplyFilters={(f) => setFilters(f)}

                renderFilterFields={({ values }) => (
                    <>

                        <Grid2 children size={12}>
                            <Field
                                name="city_id"
                                component={IdAutoCompleteField}
                                options={CityOptions}
                                label="Select City"
                                isLoading={isCityLoading}
                                onValueChange={(val) => { setCityId(val?.id) }}
                                  onSearchChange={(val)=>{setSearchCity(val)}}

                            />
                        </Grid2>
                        <Grid2 children size={12}>
                            <Field
                                name="zone_id"
                                component={IdAutoCompleteField}
                                options={ZoneOption}
                                isLoading={isLoadingZone}
                                label="Select Zone"
                                onValueChange={(value) => {
                                    setSelectedZone(value);
                                }}

                            />
                        </Grid2>
                        <Grid2 children size={12}>
                            <Field
                                name="cluster_id"
                                component={IdAutoCompleteField}
                                options={ClusterOption}
                                isLoading={isClusterLoading}
                                label="Select Cluster"

                            />
                        </Grid2>

                        <Grid2 children size={12}>
                            <Field
                                name="from"
                                component={DateFormField}
                                label="Start Date"
                                maxDate={values?.to || undefined}

                            />
                        </Grid2>
                        <Grid2 children size={12}>
                            <Field
                                name="to"
                                component={DateFormField}
                                label="End Date"
                                minDate={values?.from || undefined}

                            />
                        </Grid2>
                    </>
                )}
            />
        </>
    )
}

export default SalesReports